export default __webpack_public_path__ + "static/media/user-dark.f2a66da9.svg";